// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TQzv","top":"styles_top__1jo-V","left":"styles_left__-o23X","description":"styles_description__v6uw_"};